module.exports = __webpack_public_path__ + "static/media/Logo.17abf7c1.jpg";